export default {
	criticalConcepts: {
		label: 'Critical concepts',
		description: 'Highlight and explain the most important concepts',
	},
	practicalExamples: {
		label: 'Practical examples',
		description: 'Real-world examples that illustrate the concept',
	},
	commonMisconceptions: {
		label: 'Common misconceptions',
		description: 'Common mistakes and how to avoid them',
	},
	realWorldApplications: {
		label: 'Real-world applications',
		description: 'How this concept is applied in practice',
	},
	keyTakeaways: {
		label: 'Key takeaways',
		description: 'Essential points to remember',
	},
	historicalContext: {
		label: 'Historical context',
		description: 'How this concept developed over time',
	},
	futureImplications: {
		label: 'Future implications',
		description: 'Emerging trends and future developments',
	},
	relatedConcepts: {
		label: 'Related concepts',
		description: 'Connected ideas and how they relate',
	},
	expertInsights: {
		label: 'Expert insights',
		description: 'Advanced perspectives from experts',
	},
	practiceExercises: {
		label: 'Practice exercises',
		description: 'Exercises to apply what you learned',
	},
	selfAssessment: {
		label: 'Self-Assessment',
		description: 'Questions to test your understanding',
	},
	actionPlan: {
		label: 'Action plan',
		description: 'Practical steps to apply this knowledge',
	},
	caseStudy: {
		label: 'Case study',
		description: 'In-depth analysis of a real example',
	},
	toolsAndResources: {
		label: 'Tools & resources',
		description: 'Recommended tools and further reading',
	},
	bestPractices: {
		label: 'Best practices',
		description: 'Proven approaches and recommendations',
	},
	troubleshooting: {
		label: 'Troubleshooting',
		description: 'Common problems and solutions',
	},
}
